<template>
    <NuxtRouteAnnouncer />
    <CommonGlobalLoader v-show="!appLoadingComplete" />
    <div class="h-screen">
        <NuxtLayout>
            <NuxtPage :transition="transition" />
        </NuxtLayout>
    </div>
</template>

<script setup>
    const nuxtApp = useNuxtApp();
    const globalStore = useGlobalStore();
    const transition = usePageAltTransition(globalStore);
    useCoverRouting();
    const { bindDocumentPrefetch } = useRoutePrefetch();
    const { appLoadingComplete, pageTransitionComplete } = storeToRefs(globalStore);
    nuxtApp.hook("app:suspense:resolve", () => setTimeout(() => nuxtApp.$ScrollTrigger.refresh(true), 250));
    const isDesktop = useMediaQuery("(min-width: 1181px)");

    const { data: settings } = await useAsyncGql({
        operation: "settings"
    });

    const { data: menus } = await useAsyncGql({
        operation: "menus"
    });

    const { data: instagram } = await useAsyncGql({
        operation: "instagram"
    });

    globalStore.setSettings(settings.value?.settings);
    globalStore.setMenus(menus.value);
    globalStore.setInstagramFeed(instagram.value?.instagram);

    let unbindPrefetch = null;
    watch(
        () => appLoadingComplete.value,
        (ready) => {
            if (!ready || unbindPrefetch) return;
            unbindPrefetch = bindDocumentPrefetch();
        },
        { immediate: true }
    );

    onBeforeUnmount(() => {
        unbindPrefetch?.();
        unbindPrefetch = null;
    });

    watch(
        () => pageTransitionComplete.value,
        (state) => {
            nextTick(() => {
                useLenis(state);
                useHeader(state);
            });
        }
    );

    watch(
        () => isDesktop.value,
        (state) => {
            nextTick(() => nuxtApp.$ScrollTrigger.refresh());
            if (state) {
                nextTick(() => {
                    globalStore.setToggleMobileMenu(false);
                });
            }
        }
    );
</script>
